import { BAND_EMOJI } from "./bands.ts";
import type { Band } from "./types.ts";

export const MAX_SCORE_PER_ROUND = 500;

export interface ShareTextInput {
  roundNumber: number;
  bands: Band[];
  total: number;
  url: string;
}

/** Texto compartible sin spoilers (bandas + total + URL). */
export function buildShareText({ roundNumber, bands, total, url }: ShareTextInput): string {
  const emojis = bands.map((b) => BAND_EMOJI[b]).join("");
  return `MapaGol #${roundNumber} ⚽🌍\n${emojis} ${total}/${MAX_SCORE_PER_ROUND}\n${url}`;
}

export type ShareChannel = "native" | "whatsapp" | "x" | "copy";

export function whatsappUrl(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function xUrl(text: string, url: string): string {
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
}

export function resultUrl(origin: string, shareId: string): string {
  return `${origin.replace(/\/$/, "")}/r/${shareId}`;
}
